import { render, staticRenderFns } from "./RobotDetail.vue?vue&type=template&id=19588374&scoped=true"
import script from "./RobotDetail.vue?vue&type=script&lang=js"
export * from "./RobotDetail.vue?vue&type=script&lang=js"
import style0 from "./RobotDetail.vue?vue&type=style&index=0&id=19588374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19588374",
  null
  
)

export default component.exports